export default class BaseSelector {
  data = {};

  getProperty = (id, propertyName) => {
    if (!this.data[id]) {
      this.initializeData(id);
    }

    return this.data[id][propertyName];
  };

  getData = (id) => {
    if (!this.data[id]) {
      this.initializeData(id);
    }

    return this.data[id];
  };

  updateData = (id, newData) => {
    const currentData = this.getData(id);

    this.data[id] = { ...currentData, ...newData };
  };

  initializeData = (id) => {
    const element = document.getElementById(`${this.prefix}-${id}`);

    if (element) {
      this.data[id] = this.normalizedData(element.dataset);
    }
  };
}
